import DOMPurify from 'dompurify';
import { getOptionFromValue } from 'shared/utils';
import { jobPositionStore } from '../job-positions/JobPositionStore';

export const getJobCode = job => `#${job.codes?.[0] || job.id}`;

export const getJobDisplayTitle = job => job?.title || '';

// The public listing only exposes the client's industry, never the client
// itself, so jobs are labelled by the kind of company they belong to.
export const getJobIndustry = job => {
	const industryName = job.client?.industryName || job.client?.industry?.name;
	return industryName ? `${industryName} Company` : null;
};

export const getJobSchedule = job => {
	const schedule = getOptionFromValue(
		job.workSchedule,
		jobPositionStore.workScheduleOptions
	);
	const term = getOptionFromValue(job.term, jobPositionStore.termOptions);

	return [schedule?.label, term?.label].filter(Boolean).join(' - ') || null;
};

export const getJobLocationNames = job =>
	(job.locations || []).map(({ location }) => location?.name).filter(Boolean);

export const getJobLocations = job => {
	const locationType = getOptionFromValue(
		job.locationType,
		jobPositionStore.locationTypeOptions
	);
	const locations = getJobLocationNames(job).join(', ');

	return [locationType?.label, locations].filter(Boolean).join(' - ') || null;
};

export const getJobCreatedDate = job => {
	if (!job?.createdAt) {
		return null;
	}

	return new Date(job.createdAt).toLocaleDateString('en-US', {
		month: 'short',
		day: 'numeric',
		year: 'numeric'
	});
};

const isNonEmptyText = value =>
	typeof value === 'string' && value.replace(/<[^>]*>/g, '').trim().length > 0;

export const getJobDetailSections = job => {
	if (!job) {
		return [];
	}

	return [
		{
			key: 'description',
			title: 'Description',
			html: isNonEmptyText(job.description)
				? DOMPurify.sanitize(job.description)
				: null
		},
		{
			key: 'responsibilities',
			title: 'Responsibilities',
			items: (job.responsibilities || []).filter(Boolean)
		},
		{
			key: 'requirements',
			title: 'Requirements',
			items: (job.requirements || []).filter(Boolean)
		},
		{
			key: 'bonusPoints',
			title: 'Bonus Points',
			items: (job.bonusPoints || []).filter(Boolean)
		},
		{
			key: 'offers',
			title: 'What we Offer',
			items: (job.offers || []).filter(Boolean)
		}
	].filter(section => section.html || section.items?.length);
};
